import React, { useState, useEffect } from 'react';
import API, { rateTeacher, getMyRatings } from '../../api';
import { toast } from 'react-toastify';


const StudentTeacherRating = () => {
  const [teachers, setTeachers] = useState([]);
  const [myRatings, setMyRatings] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [hoveredStar, setHoveredStar] = useState(0);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      
      const [teachRes, ratingRes] = await Promise.all([
        API.get('/student/teachers'),
        getMyRatings()
      ]);
      setTeachers(teachRes.data);
      setMyRatings(ratingRes.data);
    } catch (err) {
      toast.error('Error loading data');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) return toast.error('Please select a rating!');
    try {
      await rateTeacher({ teacher_id: selectedTeacher, rating, feedback });
      toast.success('Rating submitted!');
      setSelectedTeacher('');
      setRating(0);
      setFeedback('');
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error submitting rating');
    }
  };

  return (
    <div>
      <h3 style={{ color: '#1a3a5c', marginBottom: '20px' }}>⭐ Rate Your Teachers</h3>

      <div style={styles.card}>
        <h4 style={{ color: '#1a3a5c', margin: '0 0 15px' }}>➕ Submit Rating</h4>
        <form onSubmit={handleSubmit}>
          <div style={styles.formGrid}>
            <div>
              <label style={styles.label}>Select Teacher</label>
              <select style={styles.input} value={selectedTeacher}
                onChange={e => setSelectedTeacher(e.target.value)} required>
                <option value="">-- Select Teacher --</option>
                {teachers.map(t => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={styles.label}>Rating</label>
              <div style={{ display: 'flex', gap: '5px', marginTop: '8px' }}>
                {[1,2,3,4,5].map(star => (
                  <span key={star}
                    style={{ fontSize: '30px', cursor: 'pointer', color: star <= (hoveredStar || rating) ? '#ffc107' : '#ddd' }}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoveredStar(star)}
                    onMouseLeave={() => setHoveredStar(0)}>
                    ★
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={styles.label}>Feedback (Optional)</label>
            <textarea style={{ ...styles.input, height: '80px', resize: 'vertical' }}
              placeholder="Write your feedback..."
              value={feedback}
              onChange={e => setFeedback(e.target.value)} />
          </div>
          <button type="submit" style={styles.submitBtn}>⭐ Submit Rating</button>
        </form>
      </div>

      <div style={styles.card}>
        <h4 style={{ color: '#1a3a5c', margin: '0 0 15px' }}>📋 My Submitted Ratings</h4>
        {myRatings.length === 0
          ? <p style={{ color: '#999', textAlign: 'center' }}>Koi rating submit nahi ki abhi tak!</p>
          : myRatings.map(r => (
            <div key={r.id} style={styles.ratingCard}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <strong style={{ color: '#1a3a5c' }}>👨‍🏫 {r.teacher_name}</strong>
                <span style={{ color: '#ffc107', fontSize: '18px' }}>
                  {'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}
                </span>
              </div>
              {r.feedback && <p style={{ color: '#666', margin: '5px 0 0', fontSize: '13px' }}>"{r.feedback}"</p>}
            </div>
          ))
        }
      </div>
    </div>
  );
};

const styles = {
  card: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', marginTop: '5px', boxSizing: 'border-box' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555' },
  submitBtn: { padding: '10px 25px', background: '#ffc107', color: '#1a3a5c', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' },
  ratingCard: { padding: '12px', border: '1px solid #eee', borderRadius: '8px', marginBottom: '10px' },
};

export default StudentTeacherRating;